import { ForSaleExclusion } from "../../../../../CoStar/Api/FusionSearch/Migrated/Criteria/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.Property.ForSaleExclusion */
export { ForSaleExclusion };
/** CoStar.Api.EnterpriseSub2.Migrated.Property.StackSpaceStatus */
export var StackSpaceStatus;
(function (StackSpaceStatus) {
    StackSpaceStatus[StackSpaceStatus["NoDataAvailable"] = 0] = "NoDataAvailable";
    StackSpaceStatus[StackSpaceStatus["Available"] = 1] = "Available";
    StackSpaceStatus[StackSpaceStatus["MovingOutOrLeaseExpiring"] = 2] = "MovingOutOrLeaseExpiring";
    StackSpaceStatus[StackSpaceStatus["MovingIn"] = 3] = "MovingIn";
    StackSpaceStatus[StackSpaceStatus["Occupied"] = 4] = "Occupied";
})(StackSpaceStatus || (StackSpaceStatus = {}));
/** CoStar.Api.EnterpriseSub2.Migrated.Property.TransitType */
export var TransitType;
(function (TransitType) {
    TransitType[TransitType["Unknown"] = 0] = "Unknown";
    TransitType[TransitType["Airport"] = 1] = "Airport";
    TransitType[TransitType["CommuterRailStation"] = 2] = "CommuterRailStation";
    TransitType[TransitType["TransitStation"] = 3] = "TransitStation";
})(TransitType || (TransitType = {}));
